<template>
  <CModal
      :centered="true"
      :show.sync="homeworkEditModal"
      size="md"
      title="ویرایش تکلیف"
  >
    <CForm class="add-homework-modal text-right">
      <CInput v-model="form.title" class="text-sm mt-3" label="عنوان"/>

      <CTextarea v-model="form.text" class="text-sm" label="توضیحات"/>
      <div class="text-sm">
        <div class="text-sm pb-2">مهلت ارسال</div>
        <date-picker
            v-model="form.expireDate"
            auto-submit
            color="#fbad18"
            format="jYYYY-jMM-jDD"
        />
      </div>
      <UploadFile
          v-if="homeworkEditModal === true"
          v-model="form.files"
          cat="HM"
          @upload-file="onUploadFile"
      />
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          class="px-5"
          color="primary"
          @click="onAddHomework"
      >
        تایید
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import UploadFile from "../../UploadFile/UploadFile.vue";

export default {
  components: {datePicker: VuePersianDatetimePicker, UploadFile},

  props: {
    value: {
      type: Boolean,
    },
    homework: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {},
      loading: false,
      homeworks: [],
    };
  },
  computed: {
    homeworkEditModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    homework(newvalue) {
      this.form = {
        title: newvalue.title,
        text: newvalue.text,
        expireDate: newvalue.expireDate,
        answerText: newvalue.answerText,
        files: newvalue.files,
      };
    },
  },
  mounted() {
    this.getHomework();
  },
  methods: {
    async onAddHomework() {
      try {
        this.loading = true;
        const payload = {
          title: this.form.title,
          text: this.form.text,
          expireDate: this.form.expireDate,
          answerText: this.form.answerText,
          files: this.form.files,
        };
        await axios.put(`/homework/${this.homework.id}`, payload);
        this.$emit("get-homework");
        this.homeworkEditModal = false;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadFile(file) {
      this.form.files = [...new Set(this.form.files.concat(file))]
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .vpd-container {
    .vpd-content {
      border-radius: 8px;

      .vpd-header {
        border-radius: 8px 8px 0 0;
      }
    }
  }

  .text-sm {
    font-size: 14px;
  }

  .survey {
    border-top: 1px solid #9da5b1;
  }
}
</style>